import { render, staticRenderFns } from "./indvidualAdvisorReport.vue?vue&type=template&id=1f249891&scoped=true"
import script from "./indvidualAdvisorReport.vue?vue&type=script&lang=js"
export * from "./indvidualAdvisorReport.vue?vue&type=script&lang=js"
import style0 from "./indvidualAdvisorReport.vue?vue&type=style&index=0&id=1f249891&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f249891",
  null
  
)

export default component.exports